import { render, staticRenderFns } from "./FavUsersTable.vue?vue&type=template&id=3b3a3e76&scoped=true"
import script from "./FavUsersTable.vue?vue&type=script&lang=ts"
export * from "./FavUsersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a3e76",
  null
  
)

export default component.exports